<template>
  <div
    class="player-wrapper"
    :class="[{ 'golf-player-wrapper': isGolfService }]"
  >
    <div class="video basic" :id="playerId" ref="player" @click="showGUI"></div>
    <!-- seek icon -->
    <div>
      <div
        class="seek-left"
        v-show="jump == 'left'"
        :style="{
          backgroundImage: 'url(' + require('@/assets/oval-ic.png') + ')',
        }"
      >
        <div class="seek-term left">-{{ seekTerm }}</div>
        <img class="seek-ic left" src="@/assets/ic-left.png" />
      </div>
      <div
        class="seek-right"
        v-show="jump == 'right'"
        :style="{
          backgroundImage: 'url(' + require('@/assets/oval-ic.png') + ')',
        }"
      >
        <div class="seek-term">+{{ seekTerm }}</div>
        <img class="seek-ic" src="@/assets/ic-right.png" />
      </div>
    </div>
    <transition name="slide-fade">
      <div class="player-btn-area" v-if="show">
        <div @click="enterKeyProc" @mouseover="moveFocus(0)">
          <img
            class="back"
            v-if="focusIndex === 0"
            src="@/assets/vod-retrun-ic-f.png"
          />
          <img class="back" v-else src="@/assets/vod-retrun-ic-u.png" />
        </div>
        <template v-if="!isLive">
          <div @click="enterKeyProc" @mouseover="moveFocus(1)">
            <img
              class="restart"
              v-if="focusIndex === 1"
              src="@/assets/vod-before-ic-f.png"
            />
            <img class="restart" v-else src="@/assets/vod-before-ic-u.png" />
          </div>
        </template>
      </div>
    </transition>
    <!-- 뒤로가기, 재시작, 재생, 멈춤, 프로그래스바 -->
    <transition name="slide-fade">
      <div class="pb-area" v-if="show">
        <div class="play-time">
          <span v-if="isLive">{{ livePlayTimeCheck }}</span>
          <span v-if="!isLive">{{ computedPlayPosition }}</span>
          <span v-if="!isLive">{{ computedPlayTime }}</span>
        </div>
        <div class="progressbar" ref="progressbar">
          <div class="innerbar" :style="innerBarStyle"></div>
          <div
            class="indicator"
            :style="indicatorStyle"
            @mousedown="dragOn"
            @mouseup="dragOff"
            v-show="mouseActivated"
            @touchstart.prevent="dragOn"
            @touchend="dragOff"
            @touchcancel="dragOff"
            @touchmove.prevent="touchMove"
          >
            <img src="@/assets/ball-indicator.png" />
          </div>
        </div>
        <div @click="enterKeyProc" @mouseover="moveFocus(2)">
          <template v-if="started">
            <img
              class="play-pause pause"
              v-if="focusIndex === 2"
              src="@/assets/stop-ic-f.png"
            />
            <img v-else class="play-pause pause" src="@/assets/stop-ic-u.png" />
          </template>
          <template v-else>
            <img
              class="play-pause pause"
              v-if="focusIndex === 2"
              src="@/assets/play-f.png"
            />
            <img v-else class="play-pause pause" src="@/assets/play-u.png" />
          </template>
        </div>
      </div>
    </transition>
    <div class="exit-popup" v-if="showPopup">
      <div class="dim"></div>
      <p class="pupup-message">홈 화면으로 이동합니다.</p>
      <button
        class="confirm"
        :class="{ focused: popupFocusIndex === 0 }"
        @click="historyBack"
        @mouseover="popupFocusIndex = 0"
        ref="button"
      >
        확인
      </button>
      <button
        class="cancel"
        :class="{ focused: popupFocusIndex === 1 }"
        @click="backKeyProc"
        @mouseover="popupFocusIndex = 1"
        ref="button"
      >
        취소
      </button>
    </div>
    <div class="movingboard" v-if="dragMode" @mouseup="dragOff">
      <div class="active-area" @mouseup="dragOff" @mousemove="mouseMove"></div>
    </div>
  </div>
</template>

<script>
import * as deviceApi from "../api/smartTv.js";
import { isGolf } from "@/utils/common";
import { NowPlayer } from "../now/player/bitmovinPlayer";
import { HYUNDAI_KEY_CODE } from "@/helpers/const.js";

export default {
  name: "player",
  props: ["contentType", "vodId"],
  data() {
    return {
      isActiveVue: true,
      playerId: "player",
      player: null,
      started: false,
      error: false,
      logInterval: null,
      logStartTime: null,
      livePlayTime: "",
      playTime: 0,
      playPosition: 0,
      playInterval: null,
      playerStartTime: 0,
      seekTerm: 5,
      jump: false,
      jumpIconTimer: null,
      show: false,
      showPopup: false,
      focusIndex: 2,
      popupFocusIndex: 1,
      guiTimer: null,
      popupTimer: null,
      progressBarX: 0,
      indicatorX: 0,
      dragMode: false,
      deepLinkPlayerCheck: false,
      networkCheck: true,
      listenerID: null,
      isGolfService: isGolf,
    };
  },
  computed: {
    isLive() {
      return this.contentType === "live";
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    lambdaInfo() {
      return this.$store.getters.lambdaInfo;
    },
    videoData() {
      return this.$store.getters.vodData;
    },
    logViewApi() {
      return this.lambdaInfo.a_view;
    },
    logData() {
      return {
        age: this.userInfo.age,
        gender: this.userInfo.gender,
        os: deviceApi.getOsType() == "lg" ? "4" : "5",
        start: this.logStartTime,
        type: this.isLive ? "L" : "V",
        subType: this.userInfo.subType,
        serviceId: this.userInfo.serviceId,
        userId: this.userInfo.userId,
        videoId: this.vodId,
      };
    },
    keyInput() {
      return this.$store.getters.keyInput;
    },
    livePlayTimeCheck() {
      return this.convertTimeString(this.livePlayTime);
    },
    innerBarStyle() {
      return {
        width: `${this.progressBarX}px`,
      };
    },
    indicatorStyle() {
      return {
        left: `${this.indicatorX}px`,
      };
    },
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
    computedPlayPosition() {
      return this.convertTimeString(this.playPosition);
    },
    computedPlayTime() {
      return " / " + this.convertTimeString(this.playTime);
    },
    progressWidth() {
      return Number(window.innerWidth) === 1920 ? 1680 : 1152;
    },
  },
  methods: {
    playerInit() {
      this.player = new NowPlayer(document.getElementById(this.playerId), {
        analytics: { customUserId: this.userInfo.userId },
      });

      this.player.onSourceLoaded(async () => {
        this.started = true;
        this.error = false;

        if (
          !this.isLive &&
          (process.env.VUE_APP_OS_TYPE === "lg" || !this.videoData.mp4Url)
        ) {
          this.setHighestVideoQuality();
        }
      });

      this.player.onSourceUnloaded(async () => {
        this.started = false;
        this.clearLogInterval();
      });

      this.player.onError((data) => {
        this.error = true;
        this.clearLogInterval();
        this.$router.replace({
          name: "err-api",
          params: {
            errorCode: data.code,
          },
        });
      });

      this.player.onPlay(async () => {
        if (this.playerStartTime == 0) {
          this.playerStartTime = this.player.getCurrentTime();
          this.checkPlayPosition();
        }
      });

      this.player.onPlaying(({ issuer }) => {
        this.started = true;
        this.sendViewLog();
        this.$progress.$emit("off:progress");
      });

      this.player.onPaused(() => {
        this.started = false;
        this.clearLogInterval();
      });

      this.player.onPlaybackFinished(() => {
        this.clearLogInterval();
        this.historyBack();
      });

      this.player.onSeeked(() => {
        this.checkPlayPosition();
      });
    },
    loadVideo() {
      let dispatchType = this.isLive ? "FETCH_LIVE_DATA" : "FETCH_VOD_DATA";

      this.$store.dispatch(dispatchType, this.vodId).then((response) => {
        //  Live 방송 상태 체크 ※ 0: 방송전, 2: 방송종료
        if (this.isLive && process.env.VUE_APP_OS_TYPE === "lg") {
          this.$progress.$emit("liveCheck", response.data.status);
          if (response.data.status == 0 || response.data.status == 2) {
            this.$progress.$emit("off:progress");
            return;
          }
        }

        if (this.isLive) {
          this.player.setMinSelectableVideoHeight(1080);
          this.player.loadVideo({ ...this.getVideoSource() });
        } else {
          const loadVideoParams = {
            videoId: this.vodId,
            type: "vod",
          };

          if (process.env.VUE_APP_OS_TYPE === "lg" || !this.videoData.mp4Url) {
            loadVideoParams.hls = this.videoData.hlsUrl;
          } else {
            loadVideoParams.progressive = this.videoData.mp4Url;
          }

          this.player.loadVideo(loadVideoParams);
        }
      });
    },
    setHighestVideoQuality() {
      const qualities = this.player.getAvailableVideoQualities();

      if (!qualities || qualities.length === 0) {
        return;
      }

      const highest = qualities.reduce((max, quality) =>
        quality.bitrate > max.bitrate ? quality : max,
      );
      this.player.setVideoQuality(highest.id);
    },
    restart() {
      if (process.env.VUE_APP_OS_TYPE == "samsung")
        document.getElementsByTagName("video")[0].currentTime = 0;
      else this.player.moveTime(0);
      this.sendViewLog();
    },
    playPause() {
      if (this.player.isPaused()) {
        this.play();
      } else {
        this.pause();
      }
    },
    play() {
      this.player.play();
      this.$progress.$emit("off:progress");
      this.showGUI();
    },
    pause() {
      this.player.pause();
      this.clearLogInterval();
    },
    stop() {
      this.pause();
      this.$progress.$emit("off:progress");
      this.clearAllTimer();
    },
    fastForWard() {
      if (this.playTime > this.playPosition + 5) {
        clearInterval(this.playInterval);
        this.playPosition += 5;
      } else {
        return;
      }

      if (process.env.VUE_APP_OS_TYPE == "samsung")
        document.getElementsByTagName(
          "video",
        )[0].currentTime = this.playPosition;
      else this.player.moveTime(this.playPosition);
      this.checkPlayPositionSeek();
    },
    reWind() {
      clearInterval(this.playInterval);
      if (0 < this.playPosition - 5) {
        this.playPosition -= 5;
      } else {
        this.playPosition = 0;
      }

      if (process.env.VUE_APP_OS_TYPE == "samsung")
        document.getElementsByTagName(
          "video",
        )[0].currentTime = this.playPosition;
      else this.player.moveTime(this.playPosition);
      this.checkPlayPositionSeek();
    },
    getVideoSource() {
      if (this.videoData.isDrm) {
        return {
          videoId: this.videoData.id,
          hls: this.videoData.hlsDrmUrl,
          hlsDvr: this.videoData.hlsDrmDvrUrl,
          dash: this.videoData.dashDrmUrl,
          dashDvr: this.videoData.dashDrmDvrUrl,
          type: this.videoData.type,
          cid: this.videoData.cid,
          userId: this.userInfo.userId,
          isDrm: this.videoData.isDrm,
        };
      } else {
        return {
          videoId: this.videoData.id,
          hls: this.videoData.hlsUrl,
          hlsDvr: this.videoData.dvrUrl,
          isDrm: this.videoData.isDrm,
          userId: this.userInfo.userId,
        };
      }
    },
    brightcoveUrlSetting(info) {
      if (info.sources?.length > 0) {
        let hlsSource = info.sources.find(
          (v) =>
            v.type === "application/x-mpegURL" && v.src.startsWith("https:"),
        );
        return {
          hlsUrl: hlsSource.src,
          poster: info.poster,
          duration: info.duration,
        };
      }
      return null;
    },
    sendViewLog() {
      if (this.userInfo.userId == undefined) {
        console.log("invalid user");
        return;
      }

      const sender = (_data) => {
        this.$store
          .dispatch("SEND_VIEW_LOG", {
            url: this.logViewApi,
            data: _data,
          })
          .then((response) => {
            if (response.data) {
              this.logStartTime = response.data.start;
            }
          });
      };

      this.logStartTime = null;
      this.clearLogInterval();

      sender(this.logData);

      this.logInterval = setInterval(() => {
        sender(this.logData);
      }, 60 * 1000);
    },
    clearLogInterval() {
      clearInterval(this.logInterval);
      this.logInterval = null;
    },
    checkPlayPosition() {
      clearInterval(this.playInterval);
      this.playTime = this.player.getDuration();

      this.playInterval = setInterval(() => {
        this.playPosition = this.player.getCurrentTime();

        if (this.playPosition - this.playerStartTime < 0) {
          this.livePlayTime = 0;
        } else {
          this.livePlayTime = this.playPosition - this.playerStartTime;
        }

        if (this.isLive) {
          this.progressBarX = this.progressWidth;
        } else {
          let currentTimeRate = this.playPosition / this.playTime;
          this.progressBarX = currentTimeRate * this.progressWidth;
        }

        if (!this.dragMode) {
          this.indicatorX = this.progressBarX;
        }
      }, 500);
    },
    checkPlayPositionSeek() {
      let currentTimeRate = this.playPosition / this.playTime;
      this.progressBarX = currentTimeRate * this.progressWidth;

      if (!this.dragMode) {
        this.indicatorX = this.progressBarX;
      }
    },
    upKeyProc() {
      if (this.showPopup == false) {
        if (this.show == true) {
          switch (this.focusIndex) {
            case 2:
              this.focusIndex = 0;
              break;
          }
        }
        this.showGUI();
      }
    },
    downKeyProc() {
      if (this.showPopup == false) {
        if (this.show == true) {
          switch (this.focusIndex) {
            case 0:
            case 1:
              this.focusIndex = 2;
              break;
          }
        }
        this.showGUI();
      }
    },
    leftKeyProc() {
      if (this.showPopup == true) {
        this.popupFocusIndex = Math.abs(this.popupFocusIndex - 1);
        this.resetPopupTimer();
      } else {
        if (!this.isLive) {
          switch (this.focusIndex) {
            case 0:
              this.focusIndex = 1;
              break;
            case 1:
              this.focusIndex = 0;
              break;
            case 2:
              if (this.started && this.networkCheck) {
                this.reWind();
                this.showJumpIcon("left");
              }
              break;
          }
        }
        this.showGUI();
      }
    },
    rightKeyProc() {
      if (this.showPopup === true) {
        this.popupFocusIndex = Math.abs(this.popupFocusIndex - 1);
        this.resetPopupTimer();
      } else {
        if (!this.isLive) {
          switch (this.focusIndex) {
            case 0:
              this.focusIndex = 1;
              break;
            case 1:
              this.focusIndex = 0;
              break;
            case 2:
              if (this.started && this.networkCheck) {
                this.fastForWard();
                this.showJumpIcon("right");
              }
              break;
          }
        }
        this.showGUI();
      }
    },
    enterKeyProc() {
      if (this.showPopup == true) {
        switch (this.popupFocusIndex) {
          case 0:
            this.historyBack();
            break;
          case 1:
            this.showPopup = false;
            break;
        }
      } else {
        if (this.show == true) {
          switch (this.focusIndex) {
            case 0:
              this.backKeyProc();
              break;
            case 1:
              if (this.networkCheck) {
                this.restart();
              }
              break;
            case 2:
              if (this.networkCheck) {
                this.playPause();
              }
              break;
          }
        }
        this.showGUI();
      }
    },
    playPauseKeyProc() {
      if (this.showPopup == false) {
        this.playPause();
        this.showGUI();
      }
    },
    backKeyProc() {
      if (this.isLive) {
        this.showPopup = !this.showPopup;
        this.hideGUI();
      } else {
        this.historyBack();
      }
    },
    historyBack() {
      this.stop();

      if (this.deepLinkPlayerCheck) {
        this.$router.replace({
          name: "home",
          params: {
            t: new Date().getTime(),
          },
        });
      } else {
        this.$router.go(-1);
      }
    },
    showGUI() {
      this.clearGuiTimer();
      this.show = true;
      // 5초동안 UI 노출
      this.guiTimer = setInterval(() => {
        if (this.dragMode == false) {
          this.hideGUI();
          this.hideJumpIcon();
        }
      }, 5000);
    },
    hideGUI() {
      this.clearGuiTimer();
      this.show = false;
      this.focusIndex = 2;
    },
    clearGuiTimer() {
      clearTimeout(this.guiTimer);
      this.guiTimer = null;
    },
    showJumpIcon(direction) {
      this.jump = direction;

      clearTimeout(this.jumpIconTimer);
      this.jumpIconTimer = null;

      this.jumpIconTimer = setTimeout(() => {
        this.hideJumpIcon();
      }, 5000);
    },
    hideJumpIcon() {
      clearTimeout(this.jumpIconTimer);
      this.jumpIconTimer = null;
      this.jump = false;
    },
    clearPlayInterval() {
      clearInterval(this.playInterval);
    },
    clearPopupTimer() {
      clearTimeout(this.popupTimer);
      this.popupTimer = null;
    },
    resetPopupTimer() {
      this.clearPopupTimer();
      this.popupTimer = setTimeout(() => {
        this.showPopup = false;
      }, 60000);
    },
    clearAllTimer() {
      this.clearPlayInterval();
      this.clearLogInterval();
      this.clearGuiTimer();
      this.clearPopupTimer();
      this.hideJumpIcon();
    },
    moveFocus(index) {
      this.showGUI();
      this.focusIndex = index;
    },
    convertTimeString(sec) {
      let hour = sec >= 3600 ? parseInt(sec / 3600) : 0;
      let min = parseInt((sec % 3600) / 60);
      let second = parseInt(sec % 60);

      if (Number.isNaN(min) || Number.isNaN(second)) {
        return "0:00:00";
      }

      if (min < 10) {
        min = "0" + min;
      }

      if (second < 10) {
        second = "0" + second;
      }

      return `${hour}:${min}:${second}`;
    },
    dragOn() {
      if (this.isLive) {
        return;
      }

      this.dragMode = true;
    },
    dragOff() {
      if (this.isLive) {
        return;
      }

      clearInterval(this.playInterval);
      this.dragMode = false;

      const moveTimeValue =
        (this.playTime * this.indicatorX) / this.progressWidth;
      this.playPosition = moveTimeValue;

      const currentTimeRate = this.playPosition / this.playTime;
      this.progressBarX = currentTimeRate * this.progressWidth;
      this.indicatorX = this.progressBarX;

      this.player.moveTime(moveTimeValue);
      this.showGUI();
    },
    touchMove(e) {
      if (!this.$refs.progressbar) {
        return;
      }

      const rect = this.$refs.progressbar.getBoundingClientRect();
      const touchX = e.touches[0].clientX - rect.left;
      this.indicatorX = Math.min(Math.max(touchX, 0), this.progressWidth);
    },
    mouseMove(e) {
      this.indicatorX = e.offsetX;
    },
    callHyundaiKeyEvent(evt) {
      if (HYUNDAI_KEY_CODE.PAUSE.includes(evt.keyCode)) {
        this.pause();
      } else if (evt.keyCode === HYUNDAI_KEY_CODE.PLAY) {
        this.play(true);
      } else if (evt.keyCode === HYUNDAI_KEY_CODE.FORWARD) {
        if (!this.isLive) {
          this.fastForWard();
          this.showJumpIcon("right");
        }
      } else if (evt.keyCode === HYUNDAI_KEY_CODE.REWIND) {
        if (!this.isLive) {
          this.reWind();
          this.showJumpIcon("left");
        }
      }
    },
    networkStateChangeListener(networkState) {
      if (networkState == webapis.network.NetworkState.GATEWAY_DISCONNECTED) {
        // Something you want to do when network is disconnected
        this.networkCheck = false;
        this.playPause();
      } else if (
        networkState == webapis.network.NetworkState.GATEWAY_CONNECTED
      ) {
        // Something you want to do when network is connected again
        this.networkCheck = true;

        if (this.isLive) {
          this.loadVideo();
        } else {
          this.playPause();
        }
      }
    },
    lgNetworkStateChangeCheck(networkState) {
      if (
        networkState.wired.state == "disconnected" &&
        networkState.wifi.state == "disconnected"
      ) {
        // network is disconnected
        this.pause();
      } else if (
        networkState.wired.state == "disconnected" &&
        networkState.wifi.state == "connected"
      ) {
        // wifi network is connected again
        this.play();
      } else if (
        networkState.wired.state == "connected" &&
        networkState.wifi.state == "disconnected"
      ) {
        // wired network is connected again
        this.play();
      }
    },
    lgNetworkCheck(successCallback) {
      // Subscription
      let subscriptionHandle;

      subscriptionHandle = webOS.service.request(
        "luna://com.palm.connectionmanager",
        {
          method: "getStatus",
          parameters: { subscribe: true },
          onSuccess: function(inResponse) {
            successCallback(inResponse);

            if (typeof inResponse.subscribed != "undefined") {
              if (!inResponse.subscribed) {
                console.log("Failed to subscribe network state");
                return;
              }
            }

            console.log("Result: " + JSON.stringify(inResponse));
          },
          onFailure: function(inError) {
            console.log("Failed to get network state");
            console.log("[" + inError.errorCode + "]: " + inError.errorText);
            return;
          },
        },
      );
    },
  },
  created() {
    if (sessionStorage.getItem("deepLink")) {
      this.deepLinkPlayerCheck = true;
      sessionStorage.removeItem("deepLink");
    }
  },
  mounted() {
    this.playerInit();
    this.loadVideo();
    this.$progress.$emit("on:progress");
    document.addEventListener("keyup", this.callHyundaiKeyEvent);

    if (process.env.VUE_APP_OS_TYPE == "samsung") {
      // SAMSUNG SMART TV Network Listener 추가
      if (webapis && webapis?.network) {
        this.listenerID = webapis.network.addNetworkStateChangeListener(
          this.networkStateChangeListener,
        );
      }
    }

    // else if (process.env.VUE_APP_OS_TYPE == "lg") {
    //   // LG SMART TV Network Check
    //   this.lgNetworkCheck(this.lgNetworkStateChangeCheck)
    // }
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.callHyundaiKeyEvent);

    if (process.env.VUE_APP_OS_TYPE == "samsung") {
      // SAMSUNG SMART TV Network Listener 추가
      if (webapis && webapis?.network) {
        webapis.network.removeNetworkStateChangeListener(this.listenerID);
      }
    }

    this.stop();
    this.player.destroy();
    this.isActiveVue = false;
    this.$progress.$emit("offLiveStatus");
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
    this.$progress.$emit("offLiveStatus");
  },
  watch: {
    keyInput(val) {
      if (this.isActiveVue) {
        switch (val.key) {
          case "ArrowUp":
            this.upKeyProc();
            break;
          case "ArrowDown":
            this.downKeyProc();
            break;
          case "ArrowLeft":
            this.leftKeyProc();
            break;
          case "ArrowRight":
            this.rightKeyProc();
            break;
          case "Enter":
            this.enterKeyProc();
            break;
          case "MediaPlayPause":
            this.playPauseKeyProc();
            break;
          case "Backspace":
            this.backKeyProc();
            break;
          case "MediaPlay":
            if (this.player.isPaused()) {
              this.play();
            }
            break;
          case "MediaPause":
            if (!this.player.isPaused()) {
              this.pause();
            }
            break;
          case "MediaStop":
            if (!this.player.isPaused()) {
              this.pause();
            }
            break;
          case "MediaTrackPrevious":
            if (!this.isLive) {
              this.reWind();
            }
            break;
          case "MediaTrackNext":
            if (!this.isLive) {
              this.fastForWard();
            }
            break;
          default:
            break;
        }
      }
    },
    showPopup(val) {
      if (val == true) {
        this.hideGUI();
        this.popupTimer = setTimeout(() => {
          this.showPopup = false;
        }, 60000);
      } else {
        this.clearPopupTimer();
      }
    },
  },
};
</script>
<style lang="less">
.player-wrapper {
  width: 1920px;
  height: 1080px;
}

.video {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
input {
  border: none;
}

.video video {
  width: 100%;
  height: 100%;
}

.back {
  position: absolute;
  width: 72px;
  height: 72px;
  left: 120px;
  top: 78px;
}
.restart {
  position: absolute;
  width: 72px;
  height: 72px;
  left: 232px;
  top: 78px;
}

.player-btn-area {
  position: absolute;
  top: 0px;
}

.pb-area {
  position: absolute;
  width: 1920px;
  height: 540px;
  top: 540px;
  left: 0;
  background-image: linear-gradient(to bottom, rgba(17, 17, 17, 0), #111111);
}
.play-pause {
  position: absolute;
  width: 120px;
  height: 120px;
  left: 900px;
  top: 366px;
}
.play-time {
  position: absolute;
  right: 120px;
  top: 254px;

  font-size: 40px;
  line-height: 0.8;
  color: #eeeeee;
}
.progressbar {
  position: absolute;
  width: 1680px;
  height: 16px;
  left: 120px;
  top: 318px;
  background-color: #595959;
}
.innerbar {
  height: 16px;
  background-color: #2affcc;
}
.indicator {
  position: absolute;
  left: 0;
  width: 40px;
  height: 40px;
  margin-left: -20px;
  margin-top: -28px;
}
.movingboard {
  position: absolute;
  left: 0px;
  right: 0px;
  width: 1920px;
  height: 1080px;
  z-index: 5;
}
.active-area {
  position: absolute;
  width: 1680px;
  height: 1080px;
  left: 120px;
  bottom: 0;
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(100px);
  opacity: 0;
}
.exit-popup {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  text-align: center;
}
.dim {
  position: absolute;
  left: 0;
  top: 0;
  width: 1920px;
  height: 1080px;
  opacity: 0.8;
  background-color: #1e1e1e;
}
.pupup-message {
  margin-top: 432px;
  font-size: 56px;
  line-height: 1;
  text-align: center;
  color: #eeeeee;
}
.confirm,
.cancel {
  width: 272px;
  height: 80px;
  background-color: #3e3e3e;
  font-size: 28px;
  color: #eeeeee;
  margin-top: 80px;
  margin-right: 27px;
  border: none;
}
.confirm.focused,
.cancel.focused {
  border: solid 4px #eeeeee;
}
.seek-left {
  position: absolute;
  left: 555px;
  top: 460px;
  width: 120px;
  height: 120px;
}
.seek-right {
  position: absolute;
  left: 1246px;
  top: 460px;
  width: 120px;
  height: 120px;
}
.seek-term {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 78px;
  height: 86px;
  line-height: 86px;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  color: #eeeeee;
}
.seek-ic {
  position: absolute;
  left: 19px;
  top: 17px;
}

.seek-ic.left {
  left: 24px;
}

.golf-player-wrapper {
  .innerbar {
    background-color: #ff4600;
  }
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .player-wrapper {
    width: 1280px;
    height: 720px;
  }

  .back {
    position: absolute;
    width: 48px;
    height: 48px;
    left: 64px;
    top: 48px;
  }
  .restart {
    position: absolute;
    width: 48px;
    height: 48px;
    left: 136px;
    top: 48px;
  }

  .pb-area {
    position: absolute;
    width: 100%;
    height: 360px;
    top: 360px;
    left: 0;
    background-image: linear-gradient(to bottom, rgba(17, 17, 17, 0), #111111);
  }

  .play-pause {
    position: absolute;
    width: 80px;
    height: 80px;
    left: 600px;
    top: 248px;
  }
  .play-time {
    position: absolute;
    right: 64px;
    top: 168px;
    font-size: 26px;
    line-height: 1;
    color: #eeeeee;
  }
  .progressbar {
    position: absolute;
    width: 1152px;
    height: 8px;
    left: 64px;
    top: 208px;
    background-color: #595959;
  }
  .innerbar {
    height: 8px;
  }

  .seek-left {
    position: absolute;
    left: 280px;
    top: 300px;
    width: 120px;
    height: 120px;
  }
  .seek-right {
    position: absolute;
    left: 880px;
    top: 300px;
    width: 120px;
    height: 120px;
  }

  .exit-popup {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    text-align: center;
  }

  .dim {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    opacity: 0.8;
    background-color: #1e1e1e;
  }
  .pupup-message {
    margin-top: 292px;
    font-size: 32px;
    line-height: 1;
    text-align: center;
    color: #ffffff;
  }

  .confirm,
  .cancel {
    width: 160px;
    height: 56px;
    background-color: #3e3e3e;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    margin-top: 80px;
    margin-right: 16px;
    border: none;
  }
  .confirm.focused,
  .cancel.focused {
    border: solid 3px #eeeeee;
  }

  .indicator {
    /* 현대 자동차에서 안 보이도록 수정 */
    display: none;
  }
}
</style>
